import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';
import { deleteContactCategory } from '../api/contactCategories';

export function useDeleteContactCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteContactCategory(id),
    onSuccess: () => {
      notification.success({ message: 'Contact category deleted' });
      void queryClient.invalidateQueries({ queryKey: ['settings-contact-categories'] });
      void queryClient.invalidateQueries({ queryKey: ['contact-categories'] });
    },
    onError: () => {
      notification.error({ message: 'Failed to delete contact category' });
    },
  });
}
